'use client';

import { motion } from 'framer-motion';
import styles from './HamburgerIcon.module.scss';

interface HamburgerIconProps {
  isOpen: boolean;
  onClick?: () => void;
  className?: string;
  'aria-label'?: string;
}

export function HamburgerIcon({ 
  isOpen, 
  onClick,
  className = '',
  'aria-label': ariaLabel
}: HamburgerIconProps) {
  return (
    <button
      className={`${styles.hamburger} ${isOpen ? styles.open : ''} ${className}`}
      onClick={onClick}
      aria-label={ariaLabel || (isOpen ? "メニューを閉じる" : "メニューを開く")}
      aria-expanded={isOpen}
      type="button"
    >
      <span className={styles.hamburgerBox}>
        <motion.span 
          className={styles.hamburgerInner}
          animate={isOpen ? "open" : "closed"}
          initial={false}
        >
          <motion.span
            className={styles.line1}
            variants={{
              closed: { rotate: 0, y: 0 },
              open: { rotate: 45, y: 7 }
            }}
            transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
          />
          <motion.span
            className={styles.line2}
            variants={{
              closed: { opacity: 1, scaleX: 1 },
              open: { opacity: 0, scaleX: 0 }
            }}
            transition={{ duration: 0.2 }}
          />
          <motion.span
            className={styles.line3}
            variants={{
              closed: { rotate: 0, y: 0 },
              open: { rotate: -45, y: -14 }
            }}
            transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
          />
        </motion.span>
      </span>
    </button>
  );
}

export default HamburgerIcon;